import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DropdownButton, Dropdown, Form } from 'react-bootstrap';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { withRouter } from 'react-router-dom';
import axios from './axios';

const House = ['1 Bedroom Apartment', '2 Bedroom Apartment', '3 Bedroom Apartment', '4 Bedroom Apartment', '5 Bedroom Apartment', '6 Bedroom Apartment'];
const HearAbout = ['Google Search', 'Google Search Ad', 'Better Business Bureau', 'Billboard Advertisement', 'UPAK', 'Yellow Pages', 'A Friend', 'I\'m a Returning Customer', 'Other (Please specify in the text below)'];
class ReserveInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sizeOfCurrentHome: 'Size of your current home',
			packingServiceRequired: '',
			storageRequired: '',
			hearedAboutUs: 'How did you hear about us',
			note: '',
			storageMonths: 0,
		};
	}

	handleSelect(eventKey, event) {
		console.log(event, House[eventKey]);
		this.setState({ sizeOfCurrentHome: House[parseInt(eventKey)] });
	}
	handleHearAboutSelect(eventKey, event) {
		console.log(event, HearAbout[eventKey]);
		this.setState({ hearedAboutUs: HearAbout[parseInt(eventKey)] });
	}
	handleChange = event => {
		this.setState({ Value: event.target.value });
	};

	otherDetailsHandler = async (e) => {
        e.preventDefault()
		
			let otherDetails = {
				sizeOfCurrentHome: this.state.sizeOfCurrentHome,
				packingServiceRequired: this.state.packingServiceRequired === 'Yes' ? true : false,
				storageRequired: this.state.storagePeriod === 'Yes' ? true : false,
				hearedAboutUs: this.state.hearedAboutUs,
				clientId: this.state.clientId,
			};
			
				this.props.history.push({ pathname: '/requestquote', state: { ...this.props.location.state, otherDetails: otherDetails } });
	}
	render() {
		return (
			<div className='contact-form--1'>
				<div className='container'>
					<div className='row row--35 align-items-start'>
						<div className='col-lg-12 order-2 order-lg-1'>
							<div className='section-title text-left mb--50'>
								<h2 className='title'>Other Details</h2>
							</div>
							<div className='form-wrapper'>
								<form onSubmit={this.otherDetailsHandler}>
									<div className='row'>
										<div className='col-lg-4 col-md-6 col-xs-6'>
											<DropdownButton className="house-select-dropdown" onSelect={this.handleSelect.bind(this)} id='dropdown-item-button' variant='outlined' title={this.state.sizeOfCurrentHome} style={{ border: '2px solid rgba(0, 0, 0, 0.1)', height: '3.2rem', borderRadius: '5px', paddingTop: '.2rem' }}>
												{House.map((opt, i) => (
													<Dropdown.Item key={i} eventKey={i}>
														{opt}
													</Dropdown.Item>
												))}
											</DropdownButton>
										</div>
										<div class='col-lg-4 col-md-6 col-xs-6'>
											<FormControl component='fieldset'>
												<FormLabel component='legend'>Will you require packing services?</FormLabel>
												<RadioGroup aria-label='packingService' name='packingService' value={this.state.packingServiceRequired} onChange={e => this.setState({ packingServiceRequired: e.target.value })}>
													<div class='row' style={{ width: '230px' }}>
														<div class='col'>
															<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
														</div>
														<div class='col'>
															<FormControlLabel value='No' control={<Radio />} label='No' />
														</div>
													</div>
												</RadioGroup>
											</FormControl>
										</div>
									</div>
									<div class='row mb--20'>
										<div class='col-lg-4 col-md-6 col-xs-6'>
											<DropdownButton
												id='dropdown-item-button'
												onSelect={this.handleHearAboutSelect.bind(this)}
												className='dropdown-toggle1'
												variant='outlined'
												title={this.state.hearedAboutUs}
												style={{ border: '2px solid rgba(0, 0, 0, 0.1)', height: '3.2rem', borderRadius: '5px', paddingTop: '.2rem' }}>
												{HearAbout.map((opt, i) => (
													<Dropdown.Item key={i} eventKey={i}>
														{opt}
													</Dropdown.Item>
												))}
											</DropdownButton>
											<label htmlFor='item04' style={{ marginTop: '2vh' }}>
												<input
													type='text'
													name='other'
													id='item04'
													value={this.state.other}
													onChange={e => {
														this.setState({ other: e.target.value });
													}}
													placeholder=''
												/>
											</label>
										</div>
										<div class='col-lg-4 col-md-6 col-xs-6'>
											<FormControl component='fieldset'>
												<FormLabel component='legend'>Do you require storage?</FormLabel>
												<RadioGroup aria-label='storage' name='storage' value={this.state.storageRequired} onChange={e => this.setState({ storageRequired: e.target.value })}>
													<div class='row' style={{ width: '230px' }}>
														<div class='col'>
															<FormControlLabel value='Yes' control={<Radio />} label='Yes' />
														</div>
														<div class='col'>
															<FormControlLabel value='No' control={<Radio />} label='No' />
														</div>
													</div>
												</RadioGroup>
											</FormControl>
											<label htmlFor='item04'>
												<input
													type='text'
													name='storageMonths'
													id='item04'
													value={this.state.storageMonths}
													onChange={e => {
														this.setState({ storageMonths: e.target.value });
													}}
													placeholder='If yes, for how long?'
												/>
											</label>
										</div>
									</div>
									<div class='row mb--20'>
										<div class='col-6'>
											<Form.Group controlId='exampleForm.ControlTextarea1'>
												<Form.Control as='textarea' value={this.state.note} onChange={e => this.setState({ note: e.target.value })} placeholder='Notes to Movers' />
											</Form.Group>
										</div>
									</div>
									{/* <label htmlFor="item04">
                                        <textarea
                                            type="text"
                                            id="item04"
                                            name="message"
                                            value={this.state.rnMessage}
                                            onChange={(e)=>{this.setState({rnMessage: e.target.value});}}
                                            placeholder="Your Message"
                                        />
                                    </label> */}
									<button disabled={this.state.sizeOfCurrentHome === ''} className='rn-button-style--2 btn-solid' onClick={this.otherDetailsHandler}>
										Submit
									</button>
								</form>
							</div>
						</div>
						{/* <div className="col-lg-6 order-1 order-lg-2">
                            <div className="thumbnail mb_md--30 mb_sm--30">
                                <img src={`${this.props.contactImages}`} alt="trydo"/>
                            </div>
                        </div> */}
					</div>
				</div>
			</div>
		);
	}
}
export default withRouter(ReserveInput);
